import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { Typography } from "@vapor/react-extended";
import { Autocomplete, Divider, Stack, TextField } from "@vapor/react-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "@onefront/react-sdk";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import SelectMultipleCheckboxes from "../SelectMultipleCheckboxes"; // Ensure the file exists and is correctly named
import SelectAndEditCheckboxArray from "../SelectAndEditCheckboxArray";
import FilterDocumentsByPeriod from "../filters/FilterDocumentsByPeriod";
import { useDocumentList } from "../../state/useDocumentList";
import Button from "@vapor/react-material/Button";
import { documentYearType, MicroCategory } from "../../../newDocuments/types";
import { documentYears } from "../../../newDocuments/DocumentsCostants";
import { getStartEndYear } from "../../../newDocuments/document-utils/pureFunctions";

const FilterInputChip = ({ filters, resetFilter }) => {
  const filteredFilters = filters.filter((filter) => !!filter.value);

  return (
    <>
      <Stack direction="row" gap="10px">
        {filteredFilters.map((filter) => (
          <Stack
            direction="row"
            sx={{
              height: "24px",
              padding: "4px 4px 4px 4px",
              margin: "4px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "4px",
              border: "1px solid  #6CF",
              background: "#DBF3FF",
              marginBottom: "5px",
            }}
          >
            <Typography
              sx={{
                color: "#004E75",
                textAlign: "center",
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "16px",
                paddingRight: "2px",
              }}
            >
              {filter.type}:
            </Typography>
            <Typography
              sx={{
                color: "#004E75",
                textAlign: "center",
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "600",
                lineHeight: "16px",
              }}
            >
              {filter.value} {filter?.selectionSize && "selezionati"}
            </Typography>
            {/* <FontAwesomeIcon
              style={{ padding: "3px", marginLeft: "3px", cursor: "pointer" }}
              onClick={() => resetFilter(filter)}
              color="#004666"
              size="sm"
              icon={faTimes}
            /> */}
          </Stack>
        ))}
      </Stack>
    </>
  );
};

interface FilterInputsProps {
  microCategories: MicroCategory[];
  tags: string[];
  handleCheckboxChange: (category: MicroCategory) => boolean | void;
  handleFilterChange: (name: string, value: any) => void;
}

const FilterInputs = ({
  microCategories,
  tags,
  handleCheckboxChange,
  handleFilterChange,
}: FilterInputsProps) => {
  const [documentYear, setDocumentYear] = useState<documentYearType>("2025");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [documentDateType, setDocumentDateType] = useState("Mese");
  const [documentTag, setDocumentTag] = useState();

  const [openFilters, setOpenFilters] = useState(false);

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const { t } = useTranslation("DOCS");

  const clearFilter = (filter) => {
    console.log(filter);
  };
  const { documentFilterOption, setIsFiltering } = useDocumentList();

  // const options = useMemo(() => {
  //   const options: {[key: string]: { name: string; checked: boolean; value: number }} = {}
  //   microCategories.forEach((mc) => {
  //     options[mc] = { name: mc, checked: true, value: 0 }
  //   })
  //   return options;
  // }, [microCategories]);

  return (
    <>
      {documentFilterOption !== "CESTINO" && (
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            style={{
              display: "flex",
              width: "80%",
              gap: "15px",
              marginBottom: "10px",
              alignItems: "self-end",
              flex: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "15px",
                alignItems: "self-start",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <Autocomplete
                  style={{ width: "auto" }}
                  disablePortal
                  value={documentYear ?? ""}
                  onChange={(e, value: documentYearType) => {
                    setDocumentYear(value);
                    const { startDate, endDate } = getStartEndYear(value);
                    handleFilterChange("dateFilters", [{ startDate, endDate }]);
                    setIsFiltering(true);
                  }}
                  options={documentYears}
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
                          width: "auto",
                        },
                      }}
                      placeholder={t("folder.chooseOption")}
                      value={documentYear ?? ""}
                      {...params}
                    />
                  )}
                />
                <SelectMultipleCheckboxes
                  options={microCategories}
                  handleCheckboxChange={handleCheckboxChange}
                />
              </div>
              <Stack
                direction="row"
                justifyContent="right"
                alignItems="center"
                borderTop="2px black"
              >
                {documentFilterOption !== "CESTINO" && (
                  <Button
                    startIcon={
                      <FontAwesomeIcon
                        icon={openFilters ? faChevronUp : faChevronDown}
                        style={{ fontSize: "16px" }}
                      />
                    }
                    sx={{ mr: "10px" }}
                    onClick={() => setOpenFilters(!openFilters)}
                  >
                    Altri filtri
                  </Button>
                )}
              </Stack>
            </div>
          </Stack>
          {openFilters && (
            <Stack
              direction="row"
              alignItems="center"
              style={{
                display: "flex",
                width: "80%",
                gap: "15px",
                marginBottom: "10px",
                alignItems: "self-end",
                flex: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  flex: "1 1 0%",
                  alignItems: "self-end",
                }}
              >
                <FilterDocumentsByPeriod
                  handleFilterChange={handleFilterChange}
                  selectedFilterYear={documentYear}
                />
              </div>
              <Divider variant="fullWidth" orientation="vertical" flexItem />
              <SelectAndEditCheckboxArray
                label={"Etichetta"}
                handleCheckboxChange={(values) => {
                  handleFilterChange("tags", values);
                }}
              />
            </Stack>
          )}
          {openFilters && (
            <div style={{ paddingBottom: "10px", marginTop: "10px" }}>
              <FilterInputChip
                filters={[
                  { type: "Document period", value: documentYear },
                  {
                    type: "Filtra per",
                    value: documentDateType,
                  },
                  { type: "Start date", value: startDate },
                  { type: "End date", value: endDate },
                  {
                    type: "Microcategories",
                    value: microCategories.filter((item) => item.checked)
                      .length,
                    selectionSize: true,
                  },
                  { type: "Tag", value: tags?.length, selectionSize: true },
                ]}
                resetFilter={clearFilter}
              />
            </div>
          )}
        </Stack>
      )}
    </>
  );
};
export default FilterInputs;
